import { cn } from "@/lib/utils";

export const RetroWindow = ({
  title = "retroplanner.exe",
  children,
  className = "",
  headerClassName = "",
  contentClassName = "",
  accent = "purple",
  testId,
}) => {
  const accentMap = {
    purple: "bg-retro-bg",
    pink: "bg-retro-pink/30",
    yellow: "bg-retro-yellow/40",
    mint: "bg-retro-mint/40",
    blue: "bg-retro-blue/40",
    cream: "bg-retro-cream",
  };
  return (
    <div
      data-testid={testId}
      className={cn(
        "relative bg-white border-[3px] border-retro-ink rounded-2xl shadow-retro overflow-hidden",
        className
      )}
    >
      <div
        className={cn(
          "border-b-[3px] border-retro-ink px-4 py-2 flex items-center gap-2",
          accentMap[accent] || "bg-retro-bg",
          headerClassName
        )}
      >
        <span className="w-3 h-3 rounded-full border-2 border-retro-ink bg-retro-pink" />
        <span className="w-3 h-3 rounded-full border-2 border-retro-ink bg-retro-yellow" />
        <span className="w-3 h-3 rounded-full border-2 border-retro-ink bg-retro-mint" />
        <span className="ml-3 font-pixel text-[10px] tracking-widest text-retro-ink truncate">
          {title}
        </span>
      </div>
      <div className={cn("p-6 md:p-8", contentClassName)}>{children}</div>
    </div>
  );
};

export default RetroWindow;
